import { useMutation } from '@tanstack/react-query';
import { getPodcasts } from '../queries/module';
import { usePodcastStore } from '../stores/podcastsStore';

export function usePodcast() {
  const setPodcasts = usePodcastStore.getState().setPodcasts;

  const { isPending, mutate } = useMutation({ 
    mutationKey: ['podcast'], 
    mutationFn: (modulo: string) => getPodcasts(modulo),
    retry: false,
    onSuccess: (result) => {
      setPodcasts(result);
    }
  });

  return { isPending, mutate };
}
